import { StoreState } from '../store-interfaces';

export const selectLeadAssignmentGroups = (state: StoreState) =>
  state.leadAssignmentGroups.entities;
